import { useStores } from "../../../core/stores/rootStore";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { action } from "mobx";
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import Card from 'react-bootstrap/Card';
import 'react-toastify/dist/ReactToastify.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { formatMonthYear, getDayNameFromDate, lpad, truncateString, getLocalizedCountryFromCurrency, isImage, isPDF, allowedExtensions } from './../../../utils';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Skeleton from 'react-loading-skeleton';
import moment from 'moment';
import Stack from 'react-bootstrap/Stack';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { confirm } from "../../../components/modal/confirmation"
import Button from 'react-bootstrap/Button';
import { saveAs } from 'file-saver';
import FormFileUpload from "../../inputs/fileupload";
import Spinner from 'react-bootstrap/Spinner';
import { NumericFormat } from 'react-number-format';
import NumberFormatted from './../../../shared/components/numberFormatted';
import Modal from 'react-bootstrap/Modal';
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import {
    IntlProvider,
    load,
    LocalizationProvider,
    loadMessages,
} from "@progress/kendo-react-intl";

const BilledExpensesForm = () => {

    let navigate = useNavigate();
    const { year, month, activityId } = useParams();
    const { t, i18n } = useTranslation();
    const { billedExpensesFormStore, utilsStore, fileStore, loginStore } = useStores();
    const { add, remove, save, getBilledExpense, isLoading, criteria, billedExpense, getTotal, getConvertedAmount, setAttachment, updateExchangeRate, isSelectedCurrencyIsTheSameAsTheExpense } = billedExpensesFormStore;
    const { /*getExchangeRates, exchangeRates,*/ getCountryCurrencies, countryCurrencies } = utilsStore;
    const { uploadAttachment, getAttachmentFile } = fileStore;
    const { accountInfo } = loginStore;
    const inputRef = useRef([]);
    const [isUploading, setIsUploading] = useState(null);
    
    
    const [fileLoading, setFileLoading] = useState(null);
    const [pdfData, setPdfData] = useState(null);
    const [showReport, setShowReport] = useState(false);
    const closeShowReport = () => {
        setPdfData(null);
        setShowReport(false);
    }

    //const isUserEditable = () => [0, 2].some(x => x === billedExpense.monthActivityStatus); //Allow edit on initial or rejected
    //const isEditable = () => [1, 3].some(x => x === accountInfo.role) && isUserEditable();
    const isEditable = () => {
        switch (accountInfo.role) {            
            default:
                return false;                
            case 3:
                return [0, 2].some(x => x === billedExpense.monthActivityStatus);
            case 1:
                return billedExpense.monthActivityStatus < 4;
        }        
    }

    const showFile = (result, attachment) => {
        var fileReader = new FileReader();
        fileReader.onload = function (event) {
            setPdfData({
                id: attachment?.id,
                data: event.target.result,
                filename: attachment?.filename,
            });
        };
        fileReader.readAsArrayBuffer(result.bytes);
        setShowReport(true);
    }

    useEffect(() => {
        Promise.all([getBilledExpense(year, month, activityId), getCountryCurrencies()/*, getExchangeRates(year, month)*/]);
    }, []);

    return (
        <div>            
            <Modal className="modal-xl" show={showReport} onHide={() => closeShowReport()}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Stack direction="horizontal" gap={3}>
                            {pdfData?.filename}

                            {isImage(pdfData?.filename) && <Button style={{ height: 30, width: 30, }} disabled={isLoading} className="float-end btn btn-secondary" type="button" size="sm"
                                onClick={async () => {
                                    setFileLoading({ id: pdfData?.id });
                                    await getAttachmentFile(pdfData?.id).then((b) => saveAs(new Blob([b.bytes]), pdfData?.filename));
                                    setFileLoading(null);
                                }}>

                                {fileLoading && fileLoading?.id === pdfData?.id ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={solid("download")} size="sm" />}
                            </Button>}
                        </Stack>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(pdfData && isImage(pdfData?.filename)) &&
                        <Stack><img style={{ height: "75vh", objectFit: "contain" }} src={URL.createObjectURL(new Blob([pdfData?.data]))} alt={pdfData?.filename} /></Stack>
                    }
                    {pdfData && isPDF(pdfData?.filename) && <LocalizationProvider language={i18n.language}><PDFViewer style={{ height: pdfData ? "75vh" : null }}
                        saveFileName={pdfData?.filename}
                        arrayBuffer={pdfData?.data} tools={["pager", "spacer", "zoomInOut", "zoom", "selection", "spacer", "search", "download"]}
                    /></LocalizationProvider>}
                </Modal.Body>
            </Modal>
            <form onSubmit={save}>
                <Card>
                    <Card.Body>
                        <Row>
                            <Col xs={4}>
                                <div style={{ alignSelf: "center" }}>
                                    <ArrowBackIosIcon disabled={isLoading} sx={{ color: "#d12b3c", cursor: "pointer" }} onClick={() => navigate(-1)} size="small" />
                                </div>
                            </Col>
                            <Col xs={4} className="text-center">
                                {isLoading ? <Skeleton width={300} /> : <h5>{formatMonthYear(new Date(criteria.year, criteria.month - 1, 1))} - {t("billedExpense")}  ({billedExpense?.currency?.shortName})</h5>}
                            </Col>
                            <Col xs={4}>

                                {
                                    (isEditable()) ?
                                        <Stack direction="horizontal" gap={2}>
                                            <span className="ms-auto" />

                                            <button disabled={isLoading} className="float-end btn btn-danger" type="button"
                                                onClick={() => navigate(-1)}>
                                                {t('cancel')}
                                            </button>

                                            <button disabled={isLoading} className="float-end btn btn-secondary" type="button"
                                                onClick={() => { add() }}>
                                                <FontAwesomeIcon icon={solid("plus")} />
                                            </button>

                                            <button disabled={isLoading} className="float-end btn btn-secondary" type="submit">
                                                {t('save')}
                                            </button>
                                        </Stack>
                                        :
                                        <></>
                                }
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Card className="mt-2 cost-expense-list">
                    <Card.Body>


                        <table className="table table-sm">
                            <thead>
                                <tr>
                                    <th style={{ width: '0%' }}>Ticket Nº</th>
                                    <th style={{ width: '5%' }}>{t('date')}</th>
                                    <th style={{ width: '25%' }}>{t('description')}</th>
                                    <th style={{ width: '15%' }}>{t('localCurrencyAmount')}</th>
                                    <th style={{ width: '10%' }}>{t('currency')}</th>
                                    <th style={{ width: '10%' }}>{t('rate')}</th>
                                    <th style={{ width: '15%' }}>{t('amountInCurrency', { param: billedExpense?.currency?.shortName })}</th>
                                    <th style={{ width: '10%' }}>{t('file')} ({allowedExtensions})</th>
                                    <th style={{ width: '10%' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    isLoading ?
                                        (
                                            Array.from(Array(30), (e, i) => {
                                                return <tr key={i}>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                    <td><Skeleton /></td>
                                                </tr>
                                            })
                                        )
                                        :
                                        billedExpense?.items?.map((expense, index) => (
                                            <tr key={index} style={{ verticalAlign: "middle" }}>
                                                <td>{lpad(index + 1, 3)}</td>
                                                <td>
                                                    <Stack direction="horizontal" >

                                                        <span style={{ width: 40 }}>{getDayNameFromDate(moment(expense.date).toDate())}</span>
                                                        <input                                                            
                                                            required
                                                            style={{ width: 100 }}
                                                            className="form-control"
                                                            value={expense.date?.substr(0, 10)}
                                                            type="date"
                                                            disabled={!isEditable()}
                                                            onChange={action((e) => {
                                                                expense.date = e.target.value;
                                                                updateExchangeRate(expense);
                                                            })} />
                                                    </Stack>
                                                </td>
                                                <td>
                                                    <input
                                                        required
                                                        placeholder={t("enterValue")}
                                                        className="form-control"
                                                        value={expense.description ?? ""}
                                                        disabled={!isEditable()}
                                                        type="text"
                                                        onChange={action((e) => { expense.description = e.target.value; })} />
                                                </td>
                                                <td>                                                    
                                                    <NumericFormat
                                                        style={{ textAlign: "right" }}
                                                        required
                                                        className="form-control"
                                                        placeholder={t("enterValue")}
                                                        disabled={!isEditable()}
                                                        onValueChange={action((values, sourceInfo) => {
                                                            expense.amountInLocalCurrency = values?.floatValue ?? ""
                                                        })}
                                                        fixedDecimalScale
                                                        valueIsNumericString={true}
                                                            decimalScale={2} allowLeadingZeros={true} value={expense.amountInLocalCurrency} thousandSeparator="'" decimalSeparator="." />                                                    
                                                </td>
                                                <td>

                                                    <select
                                                        required
                                                        className="form-control"
                                                        value={expense.currencyId}
                                                        disabled={!isEditable()}
                                                        onChange={action((e) => {
                                                            expense.currencyId = e.target.value;                                                            
                                                            updateExchangeRate(expense);

                                                        })} >
                                                        <option value="">{t("enterValue")}</option>
                                                        {countryCurrencies?.map((c, index) =>
                                                            <option key={index} value={c.id}>{`${c.code.toUpperCase()} - ${getLocalizedCountryFromCurrency(c)}`}</option>
                                                        )}
                                                    </select>
                                                </td>
                                                <td>                                                   
                                                    {expense?.rateLoading ? <Skeleton /> : <NumericFormat
                                                        style={{ textAlign: "right" }}
                                                        required
                                                        className="form-control"
                                                        placeholder={t("enterValue")}
                                                        disabled={!isEditable() || isSelectedCurrencyIsTheSameAsTheExpense(countryCurrencies, expense.currencyId, billedExpense?.currency?.shortName)}
                                                        onValueChange={action((values, sourceInfo) => {
                                                            expense.exchangeRate = values?.floatValue ?? ""
                                                        })}
                                                        value={expense.exchangeRate ?? ''}
                                                        fixedDecimalScale
                                                        valueIsNumericString={true}
                                                        decimalScale={6} allowLeadingZeros={false} thousandSeparator="'" decimalSeparator="."
                                                    />}                                                    
                                                </td>

                                                <td>
                                                    <Stack direction="horizontal"> 
                                                        <span className="ms-auto" />
                                                        <NumberFormatted number={getConvertedAmount(expense)} />
                                                    </Stack>
                                                </td>

                                                <td>
                                                    <Stack direction="horizontal" gap={1}>
                                                        <FormFileUpload label={expense.attachment?.filename ?? ""}
                                                            disabled={!isEditable()}
                                                            isUploading={isUploading} hideHover compact id="file" isLoading={isLoading} innerText={t("dragDropDocuments")} accept={allowedExtensions}
                                                            onFileSelected={
                                                                async (f) => {
                                                                    if (isUploading)
                                                                        return;

                                                                    var file = f[0];
                                                                    var data = new FormData();
                                                                    data.append('file', file);

                                                                    setIsUploading({ id: index });
                                                                    var fileId = await uploadAttachment(data);
                                                                    setIsUploading(null);

                                                                    if (Number(fileId) > 0)
                                                                        setAttachment(expense, { id: Number(fileId), filename: file.name })
                                                                }
                                                            }
                                                        />

                                                        {isUploading && expense && isUploading?.id === index && <Spinner animation="border" role="status" size="sm" />}

                                                        {isEditable() && expense.attachment?.id &&                                                          
                                                            <Button style={{ height: 30, width: 30, }} disabled={isLoading || (isUploading?.id === index)} className="float-end btn btn-secondary" type="button" size="sm"
                                                                onClick={async () => {
                                                                    if (expense.attachment?.id)
                                                                        setAttachment(expense, null);
                                                                    else
                                                                        inputRef?.current[index]?.click()
                                                                }}>
                                                                <FontAwesomeIcon icon={solid("xmark")} />
                                                            </Button>}
                                                        
                                                        {expense.attachment?.id && <Button style={{ height: 30, width: 30, }} disabled={isLoading || (isUploading?.id === index)} className="float-end btn btn-secondary" type="button" size="sm"
                                                            onClick={async () => {
                                                                var file = expense?.attachment;
                                                                setFileLoading({ id: file?.id });
                                                                await getAttachmentFile(file?.id).then((b) => showFile(b, file));
                                                                setFileLoading(null);
                                                            }}>
                                                            {fileLoading && fileLoading?.id === expense?.attachment?.id ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={solid("eye")} size="sm" />}
                                                        </Button>}

                                                    </Stack>
                                                </td>

                                                <td style={{ verticalAlign: "middle" }}>
                                                    
                                                    {
                                                        (isEditable())  &&
                                                            
                                                            <Button style={{ height: 30, width: 30, }} disabled={isLoading} className="float-end btn btn-secondary" type="button" size="sm"
                                                                onClick={async () => {
                                                                    if (await confirm(t("confirmDelete")))
                                                                        remove(index)
                                                                }}>
                                                                <FontAwesomeIcon icon={solid("trash")} />
                                                            </Button>
                                                    }
                                                </td>

                                            </tr>
                                        ))
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="2"><b>{t('total') + ' ' + billedExpense?.currency?.shortName}</b></td>                                    
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style={{ textAlign:"right" }}><b><NumberFormatted number={getTotal} /></b></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </Card.Body>
                </Card>
            </form >
        </div>
    );
};

export default observer(BilledExpensesForm);
